import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import TaskItem from '../../../../components/list/TaskItem';

function DisplayTable({ list, listLabel, listUser, listTimetable, editHandler }) {

    const stateUserList = useSelector((state) => state.userList);//Пользователи
    const [users, setUsers] = useState([]);

    useEffect(() => {
        const users_ = listUser.map(item => {
            if (stateUserList.list.filter(a => a.ID_User === item.ID_User).length > 0) {
                return {
                    ...item
                    , User_Name: stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Name_User
                    , Avatar: stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Avatar_Small
                };
            }
            else {
                return { ...item, User_Name: 'Не найден...' };
            }
        })

        setUsers(users_)
    }, [listUser, stateUserList.list]);

    return (
        <>
            {list.map((item) => (
                <TaskItem key={item.ID + '_' + item.ID_User}
                    idObject={2}
                    item={item}
                    editHandler={editHandler}
                    listLabel={listLabel.filter(a => a.ID_Item === item.ID)}
                    showPercent={false}
                    showCheckList={false}
                    listUser={users.filter(a => a.ID_TaskR === item.ID)}
                    showUser={true}
                    showTimetable={true}
                    listTimetable={listTimetable.filter(a => a.ID_TaskR === item.ID)}
                />
            ))}
            {/*list.map((item) => (
                <div key={item.ID + '_' + item.ID_User} className={"list_item mt-15 priority_border_color_" + item.Priority} onClick={() => { editHandler(item) }}>
                    <div style={{ width: "50%" }}>
                        <div className='title' >{item.Name}</div>
                        <div className='subtitle'>
                            {item.ID_Project !== null ? <div><FontAwesomeIcon icon={faDiagramProject} className="mr-5" />{item.Name_Project}</div> : <div className="text-danger">проект не выбран</div>}
                        </div>

                        {
                            listLabel.filter(a => a.ID_Item === item.ID).map((label) => (
                                <div key={item.ID + '_' + label.ID_Label} className="mr-2 badge" style={{ backgroundColor: label.Color, color: "white" }} >
                                    {label.Name}
                                </div>
                            ))
                        }
                    </div>
                    <div className="center" style={{ width: "300px" }}>
                        <UserList list={users.filter(a => a.ID_TaskR === item.ID)} id_type={item.ID_Type} show_type={true} />
                    </div>
                    <div className="end" style={{ width: "280px" }}>
                        <div>
                            {listTimetable.filter(a => a.ID_TaskR === item.ID).length === 0 ? (
                                <div className='form_error'>Нет расписания</div>
                            ) :
                                (
                                    listTimetable.filter(a => a.ID_TaskR === item.ID).map((timetable) => (
                                        <div key={timetable.ID}>
                                            <div><i className="mr-5"><FontAwesomeIcon icon={faClock} /></i>{timetable.Timetable_String} {timetable.Day_Complite !== null && (
                                                <small className="widget-subheading"><i>({timetable.Day_Complite} дн.</i>)</small>
                                            )}</div>
                                        </div>
                                    ))
                                )
                            }
                        </div>
                    </div>
                </div>
            ))*/}
        </>)
}

export default DisplayTable;